import React, { useState } from "react";
import { i18n } from '../../lang/i18n';
import { NavLink, useParams } from "react-router-dom";
import DC from "../../common/DataConnector";
import QRPrint from "../../components/QRComponent/QRPrint";
import { CustomerOrderStatus } from "../../common/Enums";
import { actLoading, actLoadingEnd } from "../../store/Actions";
import { useAppDispatch } from "../../store/hooks";

export default function Order()
{
    const dispatch = useAppDispatch()
    const { orderId } = useParams()
    const [notFound, setNotFound] = useState(false)
    const [order, setOrder] = useState<any>(undefined)
    React.useEffect(() =>
    {
        (async function ()
        {
            actLoading(dispatch)
            orderLoad()
            actLoadingEnd(dispatch)
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    async function orderLoad()
    {
        let content = await DC.Post('/customer/order-status/' + orderId, {});
        if (content.wasOk) {
            let minutes = content.data.products.length * 3;
            if (minutes < 5)
                minutes = 5;
            if (minutes > 15)
                minutes = 15;
            content.data.minutes = minutes;
            setOrder(content.data);
        } else
            setNotFound(true)
    }

    if (notFound)
        return <div className="container pt-5">
            <div className="row">
                <div className="col-12"><h2>{i18n.Order.NotFoundTitle}</h2></div>
            </div>
            <div className="row">
                <div className="col-12">
                    <p>{i18n.Order.NotFoundLine1}</p>
                    <p>{i18n.Order.NotFoundLine2}</p>
                    <p>{i18n.Order.NotFoundLine3}</p>
                </div>
            </div>
            <div className="row main-subtitle mt-1">
                <NavLink to="/" className="btn-back link-btn margin-auto"> <i className="fa fa-home" /> {i18n._BTNs.GoHome}</NavLink>
            </div>
        </div>
    if (!order)
        return <div className="container pt-5">
            <div className="row">
                <div className="col-12 text-center"><h2>{i18n.Order.Title} ...</h2></div>
            </div>
        </div>
    return (
        <div className="container pt-5">
            <div className="row">
                <div className="col-12 text-center"><h2>{i18n.Order.Title} {order.orderNumber}</h2></div>
            </div>
            {order.orderStatus.id === CustomerOrderStatus.Prepared && <div className="row">
                <div className="col-12">
                    <p className="order-ready">{i18n.Order.ReadyTitle}</p>
                </div>
                <div className="col-12 text-center">
                    <p><b>{i18n.Order.ReadyInfo}</b></p>
                </div>
            </div>}
            {order.orderStatus.id !== CustomerOrderStatus.Prepared && <div className="row">
                <div className="col-12 text-center p-2">
                    <h4>{i18n.Order.ReadyInXMinutes.replace('{minutes}', order.minutes)}</h4>
                </div>
                <div className="col-12 text-center">
                    {i18n.Order.QueueInfo.replace('{minutes}', order.minutes).split(/\r?\n/).map((line: any, index: number) => (
                        <p key={index}>
                            {line}
                        </p>
                    ))}
                </div>
            </div>}
            <div className="row">
                <div className="col-12 text-center">
                    <p>{i18n.Order.UseTheNextQR}</p>
                </div>
                <div className="col-12">
                    <QRPrint value={order.orderId + '_' + order.orderCode} />
                </div>
                <div className="col-12">
                    <p className="text-center">{order.orderCode}</p>
                </div>
            </div>
            <div className="row main-subtitle mt-1">
                <NavLink to="/" className="btn-back link-btn margin-auto"> <i className="fa fa-home" /> {i18n._BTNs.GoHome}</NavLink>
            </div>
        </div>
    )
}